import ErrorView from "../../common/ErrorView";
import React, {useEffect, useContext} from "react";
import {FullStory} from "@fullstory/browser";
import * as PropTypes from "prop-types";
import {apiContext} from "../../ApiContext";


function OpenBankingRedirectErrorContainer({mode, errorCode, applicationId}) {
  const api = useContext(apiContext);

  useEffect(() => {
    FullStory('trackEvent', {
      name: 'Open Banking Redirect Error',
      properties: {
        error_code: errorCode,
        mode: mode,
      },
    });

    if (applicationId && errorCode!=null && errorCode!=='undefined' && errorCode!=='') {
      api.updateApplicationStatusDescription(applicationId, errorCode)
    }
  }, []);


  const renderOnboardView = () => {
    if (errorCode === 'usr_opt_out') {
      return <ErrorView type='accountsNotConnected'/>;
    }
    if (errorCode === 'usr_dh_not_listed') {
      return <ErrorView type='openBankingUsrDhNotListedError'/>;
    }
    return <ErrorView type='openBankingGenericRedirectError'/>;
  };

  const renderEditView = () => {
    if (errorCode === 'usr_opt_out') {
      return <ErrorView type='userOptOutWhenEdit'/>;
    }
    if (errorCode === 'consent_not_found') {
      return <ErrorView type='unableToRenewConnection'/>;
    }
    return <ErrorView type='openBankingGenericRedirectError'/>;
  };

  return (
    <div>
      {mode === 'onboard' ? renderOnboardView() : renderEditView()}
    </div>
  );
}

OpenBankingRedirectErrorContainer.propTypes = {
  errorCode: PropTypes.string,
  mode: PropTypes.string.isRequired,
  applicationId: PropTypes.string
}

export default OpenBankingRedirectErrorContainer;
